<template>
  <v-layout row wrap>
    <v-flex xs12>
      <h2 class="display-1 mb-3">Divisions</h2>
    </v-flex>
    <v-flex xs12>
      <router-view></router-view>
    </v-flex>
  </v-layout>
</template>

<script>
  export default {
    name: 'division'
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/division/Division.vue